import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, Query } from 'utility-ts-orm';
import { Contact } from '../builders/contact_builder';

export class ContactsByRelationQuery implements IQuery {
  private _result: {
    contacts: { [type: string]: Contact[] };
    relationships: string[];
  };

  constructor(private ngContactsDatastore: IDatasource<Contact>) {
    Query.registerQuery(this, this.ngContactsDatastore);
  }

  run(): ContactsByRelationQuery {
    const contacts = _4.groupBy(this.ngContactsDatastore.values(), (contact: Contact) => {
      return contact.relationship;
    });
    const relationships = _4.keys(contacts);

    this._result = {
      contacts,
      relationships
    };

    return this;
  }

  get result() {
    return this._result;
  }

  getContactFromGroup(group: string, contactId: string): Contact {
    return _4.find(this.result.contacts[group], (contact: Contact) => {
      return contact.id === contactId;
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/queries/contacts_relationship_query.ts